import React, { useState, useEffect } from 'react'
import { Row, Col, Input, Label } from 'reactstrap';
import { TextField } from '@material-ui/core';
import CrearUsuario from '../../../components/buttons/crearUsuario';
import Loading from '../../../components/modales/loadingModal';
import { Autocomplete } from '@material-ui/lab';
import Loader from 'react-loaders'

//Redux
import { connect } from 'react-redux';
//API Calls
import { functionsHttpsCallable } from '../../../utils/FirebaseStorage/firebase';

const grupoCorreos = functionsHttpsCallable('correos_gruposCorreos');

const mapStateToProps = state => ({
    usuarioActivo: state
})


let BodyDeleteGroup = (props) => {
    const [loading, setLoading] = useState(false);
    const [groupName, setGroupName] = useState('');
    const [groupList, setGroupList] = useState([]);
    useEffect(()=>{
        async function ListaGrupos() {
            await listGroups()
        }
        ListaGrupos()
    },[])

    const listGroups = async () => {
        try {
            setLoading(true)
            const tempArr = []
            const request = await grupoCorreos({ cod_empr: 537 });Object.keys(request.data.data).forEach((key) => {
                tempArr.push({ id: key, ...request.data.data[key] })
            })
            setGroupList([...tempArr]);
        }
        catch (error) {
            console.log('error', error)
        }
        setLoading(false)
    }

    const handleDelete = async () => {
        setLoading(true)
        const body = {
            docId: groupName.id,
            cod_empr:537
        }
        await props.onClick(body);     
        setLoading(false)
    }

    if (loading) { return <div className={"loading-area"}> <Loading /> </div> }
    else {
        return (
            <div>
                <div>
                    <Row className='user-mail-modal'>
                        <Col lg='10' md='10' xs="12">
                            <Autocomplete
                                variant='outlined'
                                required
                                margin="dense"
                                options={groupList}
                                key={`key_centro_costos`}
                                id={`grupoCorreos`}
                                onChange={(event, newValue) => setGroupName(newValue)}
                                renderInput={(params) => (
                                    <TextField {...params} variant='outlined' label='Grupo de Correos' margin="normal" />
                                )}
                                getOptionLabel={(option) => option.nombre}
                                renderOption={(option) => (
                                    <React.Fragment>
                                        {option.nombre}
                                    </React.Fragment>
                                )}
                            />
                        </Col>
                        <Col lg='2' md='2' xs="12" className='user-create-button'>
                            <CrearUsuario
                                onClick={() => handleDelete()}
                                color='error'
                                tittle='Eliminar'
                            />
                        </Col>
                    </Row>
                </div>
            </div>
        );
    }
}
export default connect(mapStateToProps)(BodyDeleteGroup);